import store from "../../store/index";
export function parseConditionalStatement(
  input,
  value,
  deciderNodesValue,
  deciderNode,
  conditionevaltype
) {
  //remove 'value=' from string

  let strippedInput = input.replace(/value=/g, "");
  if (!deciderNodesValue && deciderNodesValue !== 0) return false;

  // split condition in to individual statements
  let strippedInputAndArrayed = strippedInput.split(/\b(or|and)\b/);
  //eval statment
  if (deciderNodesValue?.length === 1) {
    return evaluateConditions(
      strippedInputAndArrayed,
      deciderNodesValue[0],
      deciderNode
    );
  }
  //check for array input
  if (deciderNodesValue?.length > 1 && Array.isArray(deciderNodesValue)) {
    return evaluateConditionsAgainstArray(
      strippedInputAndArrayed,
      deciderNodesValue,
      deciderNode,
      conditionevaltype
    );
  }

  return evaluateConditions(
    strippedInputAndArrayed,
    deciderNodesValue,
    deciderNode
  );
}
let showNode = false;
let andFlag = false;

function evaluateConditions(conditionArray, deciderNodesValue, deciderNode) {
  // substitute conditional dependent value

  for (let condition of conditionArray) {
    //check if decider is boolean

    if (
      condition.search("parentBoolified") != -1 &&
      deciderNodesValue &&
      deciderNodesValue !== 0
    ) {
      const parentBoolified = Boolean(
        !deciderNode.meta.choices.indexOf(deciderNodesValue)
      );
      conditionArray[conditionArray.indexOf(condition)] = condition.replace(
        "$parentBoolified",
        parentBoolified
      );
    }

    if (
      condition.search("parent ") != -1 &&
      deciderNodesValue &&
      deciderNodesValue !== 0
    ) {
      conditionArray[conditionArray.indexOf(condition)] = condition.replace(
        "$parent",
        deciderNodesValue
      );
    }
  }

  for (const condition of conditionArray) {
    if (condition == "or") {
      if (showNode) {
        break;
      } else {
        continue;
      }
    }
    if (condition == "and") {
      if (showNode) {
        andFlag = true;
      } else {
        break;
      }
    }
    //check for operator condition and if decider node is falsy or empty array

    if (deciderNodesValue instanceof Array) {
      return false;
    }

    if (condition.match(/(<|>|==)/)) {
      showNode = eval(condition);
    }

    //check for NO operator condition
    if (!condition.match(/(<|>|==)/)) {
      if (deciderNodesValue == condition.trim()) {
        showNode = true;
      } else {
        showNode = false;
      }
    }
  }
  return showNode;
}
export function rebuildConditionalStatement(conditionalStatement) {
  //remove 'value=' from string
  let strippedInput = conditionalStatement.replace(/value=/g, "");
  // split condition in to individual statements
  let strippedInputAndArrayed = strippedInput.split(/\b(or|and)\b/);

  return generateConditionOptionsObject(strippedInputAndArrayed);
}
function generateConditionOptionsObject(conditionArray) {
  let ConditionOptionObject = {
    valueArray: [],
    conditionChainOptions: []
  };
  for (const condition of conditionArray) {
    if (condition == "or" || condition == "and") {
      ConditionOptionObject.conditionChainOptions.push(condition);
      // break loop to not match the operatorless search
      continue;
    }

    //check for operator condition
    if (condition.match(/(<|>|==)/)) {
      ConditionOptionObject.valueArray.push(condition.trim());
    }

    //check for NO operator condition
    if (!condition.match(/(<|>|==)/)) {
      ConditionOptionObject.valueArray.push(condition);
    }
  }
  return ConditionOptionObject;
}
function evaluateConditionsAgainstArray(
  conditionArray,
  parentNodesValueArray,
  deciderNode,
  conditionevaltype
) {
  debugger;

  if (conditionevaltype === "contains") {
    for (let cond of conditionArray) {
      if (parentNodesValueArray.includes(cond)) {
        return (showNode = true);
      }
    }
  } else {
    let conditionArrayFiltered = removeConditionsFromArray(conditionArray);
    // remove /,/  from array
    conditionArrayFiltered[0] = conditionArrayFiltered[0]
      .replace("/,/ ", "")
      .split(" ");

    if (
      JSON.stringify(conditionArrayFiltered[0].sort()) ===
      JSON.stringify(parentNodesValueArray.sort())
    ) {
      return (showNode = true);
    } else {
      return (showNode = false);
    }
  }
}
function removeConditionsFromArray(arr) {
  let newArr = [];
  for (const condition of arr) {
    if (condition != "and") {
      newArr.push(condition.trim());
    }
  }
  return newArr;
}
let idsToHide = [];
export function GetRecordConditionalHiddenIds(record) {
  idsToHide = [];
  searchRecordChildrenAndCheckConditional(record.children, record._id);
  return idsToHide;
}
async function searchRecordChildrenAndCheckConditional(
  childrenArray,
  wholeRecordId
) {
  for (let child of childrenArray) {
    if (child.meta["condition-type"]) {
      let deciderNode;
      let deciderNodeMostRecentValue;
      const res = await store.dispatch("getRecordItemOnDemand", {
        recorditemid: child.meta["condition-node"],
        recordid: wholeRecordId
      });

      deciderNode = res;
      if (res?.value?.length) {
        deciderNodeMostRecentValue =
          res.value[deciderNode.value.length - 1].val[0];
      } else {
        deciderNodeMostRecentValue = undefined;
      }

      if (
        !parseConditionalStatement(
          child.meta["condition"],
          child.value,
          deciderNodeMostRecentValue,
          deciderNode
        )
      ) {
        idsToHide.push(child._id);
      }
    }
    if (child.children.length > 0) {
      searchRecordChildrenAndCheckConditional(child.children, wholeRecordId);
    }
  }
}
